import { render, staticRenderFns } from "./adminDetails.vue?vue&type=template&id=6ba3fce2"
import script from "./adminDetails.vue?vue&type=script&lang=js"
export * from "./adminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports